class AppContainer {
  constructor(appEvents, APP_EVENTS) {
    'ngInject';

    this.appEvents = appEvents;
    this.APP_EVENTS = APP_EVENTS;
  }
  $postLink() {
    this.appEvents.emit(this.APP_EVENTS.start);
  }
}

export default {
  controller: AppContainer,
  template: `
    <app>
      <ng-transclude></ng-transclude>
    </app>
  `,
  transclude: true,
};
